function checkPassword(password_new, password_repeat) {
  let checks = {
    password_length: 0,
    contains_eight_characters: false,
    contains_number: false,
    contains_uppercase: false,
    contains_special_character: false,
    password_match: false,
    valid_password: false
  }
  
  
  checks.password_length = password_new.length;
  const format = /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>\/?~-]/;

  if (checks.password_length >= 8) {
    checks.contains_eight_characters = true;
  } else {
    checks.contains_eight_characters = false;
  }

  checks.contains_number = /\d/.test(password_new);
  checks.contains_uppercase = /[A-Z]/.test(password_new);
  checks.contains_special_character = format.test(password_new);
  checks.password_match = password_new.length > 0 && (password_new === password_repeat);

  if (checks.contains_eight_characters === true &&
    checks.contains_special_character === true &&
    checks.contains_uppercase === true &&
    checks.password_match === true &&
    checks.contains_number === true) {
    checks.valid_password = true;
  } else {
    checks.valid_password = false;
  }

  return checks
}

export {
  checkPassword
}